import { mapState, mapGetters } from 'vuex';
import { get } from 'lodash';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import formCheckbox from '@/components/market/market-detail-charts/checkbox/checkbox.vue';
import { uuidv4 } from '@/utils/helpers';

export default {
  components: {
    formCheckbox,
    swiper,
    swiperSlide,
  },
  props: {
    contracts: {
      type: Array,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
    };
  },
  computed: {
    ...mapState('market', ['chartType']),
    ...mapGetters('app', ['isLayoutDesktop']),
    swiperOption() {
      const self = this;
      return {
        slidesPerView: 'auto',
        freeMode: true,
        watchOverflow: true,
        spaceBetween: 10,
        roundLengths: true,
        onInit(swiper) {
          self.updateNavigationState(swiper);
        },
        onTransitionEnd(swiper) {
          self.updateNavigationState(swiper);
        },
        onTouchEnd(swiper) {
          self.updateNavigationState(swiper);
        },
        onReachBeginning() {
          self.canScrollLeft = false;
        },
        onReachEnd() {
          self.canScrollRight = false;
        },
      };
    },
    showImage() {
      return get(this.chartOptions, 'showContractImagesOnLegend', false);
    },
  },
  methods: {
    updateNavigationState(swiperInst) {
      const inst = swiperInst || (this.$refs.swiper && this.$refs.swiper.swiper);
      if (inst) {
        this.canScrollLeft = !inst.isBeginning;
        this.canScrollRight = !inst.isEnd;
      }
    },
    scrollLeft() {
      this.$refs.swiper.swiper.slidePrev();
    },
    scrollRight() {
      this.$refs.swiper.swiper.slideNext();
    },
    contractName(item) {
      const regionUUID = get(this.chartOptions, 'regionUUID', null);
      if (regionUUID !== null) {
        return `checkbox-${regionUUID}-${item.contractName}-${item.marketId}${uuidv4()}`;
      }
      return `checkbox-${item.contractName}-${item.marketId}${uuidv4()}`;
    },
    imageStyleModifiers(item) {
      return {
        'border-color': item.lineColor,
        'background-image': `url(${item.contractImageSmallUrl})`,
      };
    },
    onChange(item, checked) {
      this.$emit('toggleItem', item, checked);
    },
    checkboxColor(item) {
      return item.additional ? item.additionalLineColor : item.lineColor;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-detail-charts/table/table.js